import { useAuthStore } from "@/states";
import { useParams } from "react-router";

/**
 * Returns the organisation route base for the current user context.
 */
export const useOrgRouteBase = () => {
  const role = useAuthStore((state) => state.user?.role);
  const { tenantId } = useParams();

  if (role === "super_admin" && tenantId) {
    return `/admin/tenants/${tenantId}/org`;
  }

  return "/org";
};

/**
 * Builds an organisation route path from a child segment.
 * @param segment Child segment under the organisation base route.
 */
export const useBuildOrgRoute = () => {
  const basePath = useOrgRouteBase();

  return (segment: string) => `${basePath}/${segment.replace(/^\/+/, "")}`;
};
